import {
  Avatar,
  Box,
  Group,
  Paper,
  Stack,
  Text,
  ThemeIcon,
} from "@mantine/core";
import { useSessionStore } from "../../../../stores/UserStore";
import { IconCheck, IconChevronDown } from "@tabler/icons-react";

const UserItem = ({ user, active, onClick }) => {
  const reseller = useSessionStore((s) => s.reseller);
  return (
    <Paper
      key={user?.id}
      component={Stack}
      align="center"
      justify="center"
      withBorder
      onClick={onClick}
      className="user-item"
      bg={active ? "#ffffff" : "#ffffff66"}
      p={"sm"}
      py={"xs"}
      h={64}
      style={{
        cursor: "pointer",
        overflow: "hidden",
        borderColor: "var(--mantine-color-primary-0)",
      }}
      pos={"relative"}
    >
      <Group w={"100%"} wrap="nowrap" gap={"xs"} pos={"relative"}>
        <Avatar
          color="initials"
          name={`${user?.first_name} ${user?.last_name}`}
          radius={"xl"}
          size={32}
          variant="filled"
        />
        {user?.is_subscription_active === "subscriber" && (
          <ThemeIcon
            pos={"absolute"}
            bottom={-4}
            left={20}
            style={{ zIndex: 8 }}
            variant="filled"
            size={14}
            radius={"xl"}
          >
            <IconCheck />
          </ThemeIcon>
        )}
        <Text fw={500} truncate="end" size="sm">
          {user?.first_name} {user?.last_name}
        </Text>
        <Text size="xs" opacity={0.35} ml={"auto"}>
          #{user?.id}
        </Text>
        <IconChevronDown
          size={24}
          className="bump"
          opacity={active ? 1 : 0.4}
          style={{
            transform: active ? "rotate(-90deg)" : "none",
            transition: "all ease .3s",
          }}
        />
      </Group>

      {user?.in_a_reseller && reseller?.name === "Magileads" && (
        <Box bg={"red"} pos={"absolute"} top={0} right={0} h={"100%"} w={2} />
      )}
    </Paper>
  );
};

export default UserItem;
